import React from 'react';
import ColombiaFlagAccent from './ColombiaFlagAccent';

export default function PageSectionHeader({
  as: Heading = 'h2',
  eyebrow,
  eyebrowClassName = 'bg-slate-100 text-slate-600 text-[10px] font-bold px-3 py-1 rounded-full uppercase tracking-widest',
  title,
  titleClassName = 'mt-5 text-3xl font-extrabold leading-tight sm:text-4xl md:text-5xl',
  description,
  descriptionClassName = 'text-slate-500 max-w-2xl mx-auto mt-4',
  showFlag = true,
  flagSize = 'sm',
  flagClassName = 'my-5',
  className = '',
  children
}) {
  return (
    <div className={`text-center ${className}`}>
      {eyebrow && (
        <span className={eyebrowClassName}>
          {eyebrow}
        </span>
      )}
      {title && <Heading className={titleClassName}>{title}</Heading>}
      {showFlag && <ColombiaFlagAccent size={flagSize} className={flagClassName} />}
      {description && <p className={descriptionClassName}>{description}</p>}
      {children}
    </div>
  );
}
